import { useLocation } from "react-router";

import { ArrowLeft } from "components/icons/generated";
import LinkButtonIcon from "ds/components/ButtonIcon/LinkButtonIcon";
import useTypedContext from "hooks/useTypedContext";

import { BreadcrumbsContextData } from "./Context";
import styles from "./styles.module.css";

const BreadcrumbStepBack = () => {
  const items = useTypedContext(BreadcrumbsContextData);
  const location = useLocation();

  if (items.length <= 0) return null;

  const link = items?.[items.length - 2]?.link || "/";

  return (
    <LinkButtonIcon
      icon={ArrowLeft}
      to={link}
      className={styles.stepBack}
      variant="ghost"
      analyticsTitle="Go back arrow clicked"
      analyticsProps={{
        fromPathname: location.pathname,
        toPathname: link.split("?")[0],
      }}
    >
      Go back
    </LinkButtonIcon>
  );
};

export default BreadcrumbStepBack;
